import React from "react";

export const GradientBackground = () => {
  return (
    <>
      <style>
        {`
          .gradient {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: var(--gradient-opacity, 1);
            background: radial-gradient(ellipse at var(--gradient-position), var(--gradient-color), transparent 60%);
            animation: var(--animation-name) var(--animation-duration) ease-in-out infinite;
            mix-blend-mode: hard-light;
          }

          .gradient:nth-of-type(1) {
            --gradient-color: var(--purple-100);
            --gradient-position: -50% -80%;
            --animation-duration: 30s;
            --animation-name: gradientAnimation1;
            --gradient-opacity: 0.4;
          }
          .gradient:nth-of-type(2) {
            --gradient-color: var(--violet-100);
            --gradient-position: 80% 10%;
            --animation-duration: 40s;
            --animation-name: gradientAnimation2;
            --gradient-opacity: 0.2;
          }
          .gradient:nth-of-type(3) {
            --gradient-color: var(--orange-50);
            --gradient-position: 70% 70%;
            --animation-duration: 35s;
            --animation-name: gradientAnimation3;
            --gradient-opacity: 0.5;
          }
          .gradient:nth-of-type(4) {
            --gradient-color: var(--purple-100);
            --gradient-position: 100% 100%;
            --animation-duration: 45s;
            --animation-name: gradientAnimation4;
            --gradient-opacity: 0.8;
          }

          @keyframes gradientAnimation1 {
            0%, 100% { transform: translate(0%, 0%) scale(1); }
            50% { transform: translate(10%, -10%) scale(1.2); }
          }
          @keyframes gradientAnimation2 {
            0%, 100% { transform: translate(0%, 0%) scale(1); }
            50% { transform: translate(-15%, 15%) scale(1.4); }
          }
          @keyframes gradientAnimation3 {
            0%, 100% { transform: translate(0%, 0%) scale(1); }
            50% { transform: translate(5%, 5%) scale(1.3); }
          }
          @keyframes gradientAnimation4 {
            0%, 100% { transform: translate(0%, 0%) scale(1); }
            50% { transform: translate(-10%, -5%) scale(1.4); }
          }
        `}
      </style>
      <div
        className="-z-1 fixed inset-0 overflow-hidden bg-white"
        style={{ filter: "url(#noise)" }}
      >
        <div className="z-1 absolute inset-0">
          <div className="gradient" />
          <div className="gradient" />
          <div className="gradient" />
          <div className="gradient" />
        </div>
        <svg className="z-2 absolute inset-0 hidden h-full w-full">
          <filter id="noise">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.8"
              numOctaves="1"
              result="turbulence"
            />
            <feColorMatrix
              type="saturate"
              values="0"
              x="0%"
              y="0%"
              width="100%"
              height="100%"
              in="blend"
              result="colormatrix1"
            />
            <feComponentTransfer
              x="0%"
              y="0%"
              width="100%"
              height="100%"
              in="colormatrix1"
              result="componentTransfer"
            >
              <feFuncR type="identity" />
              <feFuncG type="identity" />
              <feFuncB type="identity" />
              <feFuncA type="linear" slope="0.55" intercept="-0.3" />
            </feComponentTransfer>

            <feBlend
              mode="color-burn"
              in="SourceGraphic"
              in2="componentTransfer"
            />
          </filter>
        </svg>
      </div>
    </>
  );
};
